import { Component, OnInit, OnDestroy } from '@angular/core';
import { WorkflowModel } from '../../../../model/workflowModel';
import { BrokerAuditDataModel } from '../../../../model/brokerAuditDataModel';
import { SubmitBrokerAuditDataRequestModel } from '../../../../model/submitBrokerAuditDataRequestModel';
import { Subscription } from 'rxjs';
import { MessageModel } from '../../../../model/models';
import { SubmitBrokerAuditQuestionnaireRequestModel } from '../../../../model/submitBrokerAuditQuestionnaireRequestModel';
import { StartFunctionResponseModel } from '../../../../model/startFunctionResponseModel';
import { Router } from '@angular/router';
import { BrokerAuditDeclarationService } from '../../broker-audit-declaration.service';
import { StartFunctionService } from '../../../../shared/utils/start-function.service';
import { CurrentPageWatcherService } from '../../../../shared/utils/CurrentPageWatcher';
import { StorageService } from '../../../../shared/security/StorageService';
import { BadQuestionnaireModel } from '../../../../model/badQuestionnaireModel';
import * as $ from 'jquery';

@Component({
  selector: 'app-bad-questionnaire-save-data',
  templateUrl: './bad-questionnaire-save-data.component.html',
  styleUrls: ['./bad-questionnaire-save-data.component.css']
})
export class BadQuestionnaireSaveDataComponent implements OnInit, OnDestroy {
  workflow: WorkflowModel = new WorkflowModel();
  lastUpdated: Date = null;
  startFunction: StartFunctionResponseModel;
  badQuestionnaireDataModel: BadQuestionnaireModel = new BadQuestionnaireModel();

  notifyBrokerAuditLastUpdatedSubscription = new Subscription();

  userMessages: Array<MessageModel> = [];
  constructor(private router: Router,
    private brokerAuditDeclarationService: BrokerAuditDeclarationService,
    private startFunctionService: StartFunctionService,
    private currentPageWatcher: CurrentPageWatcherService,
    private storageService: StorageService) { }
 
  ngOnInit() {
    this.startFunction = this.storageService.getStartFunctionData();

    this.workflow = this.brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel;


    this.notifyBrokerAuditLastUpdatedSubscription = this.brokerAuditDeclarationService.getNotifyBrokerAuditLastUpdatedQuestionnaire().subscribe(
      (lastUpdatedData : Date) => {
        let date = new Date(lastUpdatedData);

        console.log(date);
        let year = date.getFullYear();
        if(year != 1){
          this.lastUpdated = lastUpdatedData;
        }
      }
    );
  }
  submitBADQuestionnaire() {
    this.currentPageWatcher.clearUserMessage();
    this.brokerAuditDeclarationService.getNotifySaveData().emit(true);
  }

  ngOnDestroy(): void {
    this.notifyBrokerAuditLastUpdatedSubscription.unsubscribe();
    // this.currentPageWatcher.clearUserMessage();
  }

}



// WEBPACK FOOTER //
// ./src/app/broker/broker-audit-declaration/questionnaire-broker-audit-declaration/bad-questionnaire-save-data/bad-questionnaire-save-data.component.ts